import { useTranslation } from 'react-i18next';
export default function useGetValidationStrings() {
  const {
    t
  } = useTranslation();

  // Validation strings
  const onlyString = t('validation.only_string');
  const noSpecialCharacters = t('validation.no_special_characters');
  const noSpecialCharactersExclamation = t('validation.exclamation_no_special_characters');
  const onlyNumbers = t('validation.only_numbers');
  const containsSixteenNumbers = t('validation.contains_sixteen_numbers');
  const emailFormat = t('validation.email_format');
  const confirmEmailFormat = t('validation.confirm_email_format');
  const phoneNumber = t('validation.phone_number');
  const address = t('validation.address');
  const noNumbers = t('validation.no_numbers');
  const registrationNumber = t('validation.registration_number');
  const dateFormat = t('validation.date_format');
  const dateFormatAlt = t('validation.date_format_alt');
  const atLeastOneChar = t('validation.must_have_one_char');
  const validateDate = t('validation.date_format');
  const required = t('validation.is_required');
  const ageLimit = t('validation.age_limit');
  const norwegianPostalCode = t('validation.norwegian_postal_code');
  const norwegianPostalCity = t('validation.norwegian_postal_city');
  const norwegianOrganizationNumber = t('validation.organization_number');
  const organizationNumberExists = t('validation.org_number_exists');
  return {
    onlyString,
    noSpecialCharacters,
    noSpecialCharactersExclamation,
    onlyNumbers,
    containsSixteenNumbers,
    emailFormat,
    confirmEmailFormat,
    phoneNumber,
    address,
    noNumbers,
    registrationNumber,
    dateFormat,
    dateFormatAlt,
    atLeastOneChar,
    validateDate,
    required,
    ageLimit,
    norwegianPostalCode,
    norwegianPostalCity,
    norwegianOrganizationNumber,
    organizationNumberExists
  };
}